import { point, vector } from '../../../elements/index';
import { ICON_DEFAULT_FOREGROUND_COLOR } from '../../../graphConstants';
import { ARC_SMALL_LEFT, SvgPathBuilder } from '../../../svg/SvgPathBuilder';
import { makeTag } from '../../../svg/index';
import { PI_RADIANS_225, PI_RADIANS_315 } from '../../../utils/angles';
import {
  type NodeIconOptions,
  type NodeTypeIcon,
  nodeIconDefaultOptions,
} from '../NodeTypeIcon';
import { createCircleNodeTypeIcon, wrapNodeIconInSvgTag } from '../common';
import { drawCircleBackground } from '../drawIconBackground';

const DIAMETER = 40;
const CIRCLE_CENTER = point.create(0, 8.8);
const CIRCLE_RADIUS = 4;
const ARC_START_VECTOR = vector.unit(PI_RADIANS_225);
const ARC_END_VECTOR = vector.unit(PI_RADIANS_315);

function createApIcon(options: NodeIconOptions = {}): string {
  const opts = { ...nodeIconDefaultOptions, ...options };

  const getApArc = (distance: number) =>
    makeTag('path', {
      d: new SvgPathBuilder()
        .moveTo(point.createOnVector(CIRCLE_CENTER, ARC_START_VECTOR, distance))
        .circleTo(
          distance,
          ARC_SMALL_LEFT,
        )(point.createOnVector(CIRCLE_CENTER, ARC_END_VECTOR, distance))
        .build(),
      fill: 'none',
      stroke: ICON_DEFAULT_FOREGROUND_COLOR,
      'stroke-width': 4,
    });

  const icon = `
    ${drawCircleBackground(DIAMETER / 2, opts.style)}
    ${makeTag('circle', {
      cx: CIRCLE_CENTER.x,
      cy: CIRCLE_CENTER.y,
      fill: ICON_DEFAULT_FOREGROUND_COLOR,
      r: CIRCLE_RADIUS,
    })}
    ${getApArc(8.4)}
    ${getApArc(14.8)}
    ${getApArc(21.2)}
  `;

  return wrapNodeIconInSvgTag(icon, DIAMETER, DIAMETER, 'center', opts);
}

export const apIcon: NodeTypeIcon = createCircleNodeTypeIcon(
  DIAMETER,
  createApIcon,
);
